import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Planer from "../views/Home/Planer.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    component: Home,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: "/",
        name: "Home",
        component: Planer
      }
    ]
  },
  {
    path: "/notes",
    name: "Notes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "notes" */ "../views/Notes.vue")
  },
  {
    path: "/recipes",
    name: "Recipes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "recipes" */ "../views/Recipes.vue")
  },
  { path: "/", redirect: "/home" }
];

const router = new VueRouter({
  routes
});

export default router;
